import ChartBase, { ChartType } from "./ChartBase";
import BPMEvent from "./events/BPMEvent";
import HoldEvent from "./events/HoldEvent";
import HoldEndEvent from "./events/HoldEndEvent";
import NoteEvent from "./events/NoteEvent";
import StopEvent from "./events/StopEvent";
import MineEvent from "./events/MineEvent";
import WarpEndEvent from "./events/WarpEndEvent";
import WarpEvent from "./events/WarpEvent";
export default class ChartStepmania extends ChartBase {
    constructor() {
        super(...arguments);
        this.hasWarp = false;
    }
    parse(data) {
        let bucket = { 'charts': [] };
        let pattern = /#([a-z]+):(.*?);/gis;
        let match;
        while (match = pattern.exec(data)) {
            match[1] = match[1].toLowerCase();
            if (ChartStepmania.fields_array.indexOf(match[1]) == -1)
                continue;
            switch (match[1]) {
                case 'bpms':
                case 'stops':
                case 'freezes':
                    bucket[match[1]] = this.getListValues(match[2].trim());
                    this.hasWarp || (this.hasWarp = this.checkForWarp(bucket[match[1]]));
                    break;
                case 'notes':
                    let values = match[2].split(":");
                    for (let i = 0; i < values.length; i++)
                        values[i] = values[i].trim();
                    let chart = {
                        columns: this.smStandardType(values[0]),
                        type: values[0],
                        desc: values[1],
                        diff_class: values[2],
                        diff_meter: parseFloat(values[3]),
                        radar_values: values[4] // 0.000,0.000,0.000,0.000,0.000
                    };
                    // filter out anything except notes and commas
                    let notesData = values[5].split(/(\r\n|\n|\r)/);
                    for (let i = 0; i < notesData.length; i++) {
                        let pos = notesData[i].indexOf('//');
                        if (pos !== -1)
                            notesData[i] = notesData[i].substring(0, pos);
                        notesData[i] = notesData[i].trim();
                    }
                    chart.data = this.parseNoteData(notesData.join('').split(","), chart.columns);
                    bucket.charts.push(chart);
                    break;
                default:
                    if (ChartStepmania.fields_number.indexOf(match[1]) != -1)
                        bucket[match[1]] = parseFloat(match[2]);
                    else
                        bucket[match[1]] = match[2];
                    break;
            }
            // Setup BPMS
            let bpms = bucket.bpms || [];
            bpms.sort(this.keyPairSort);
            if (bpms.length <= 0)
                bpms[0] = [0, 60]; // No BPM, default to 60.
            bpms[0][0] = 0; // First BPM starts at beat 0.
            bucket.bpms = bpms;
            // Setup Stops
            let stops = bucket.stops || bucket.freezes || [];
            stops.sort(this.keyPairSort);
            bucket.stops = stops;
        }
        this.finalizeNoteData(bucket);
        // Standardize Output
        this.info = {
            title: bucket.title,
            titleTranslit: bucket.titletranslit,
            subtitle: bucket.subtitle,
            subtitleTranslit: bucket.subtitletranslit,
            artist: bucket.artist,
            artistTranslit: bucket.artisttranslit,
            credit: bucket.credit,
            creditBanner: bucket.cdtitle,
            banner: bucket.banner,
            background: bucket.background,
            music: bucket.music,
            offset: bucket.offset,
            sampleStart: bucket.samplestart,
            sampleLength: bucket.samplelength,
            bpms: bucket.bpms,
            stops: bucket.stops
        };
        bucket.charts.forEach(chart => {
            this.charts.push({
                columns: chart.columns,
                difficulty: chart.diff_meter,
                name: chart.diff_class,
                timeline: chart.timeline
            });
        });
        // Set Types
        this._validTypes = ChartType.CMOD | ChartType.XMOD;
        return true;
    }
    parseNoteData(measure_data, column_count = 4) {
        let output = [];
        let len = measure_data.length;
        let hold_mapping = [];
        for (let i = 0; i < len; i++) {
            let measure = measure_data[i];
            let barsPerMeasure = measure.length / column_count;
            let subRows = (192 /* RowCount.PER_MEASURE */ / barsPerMeasure);
            for (var currentNoteBar = 0; currentNoteBar < barsPerMeasure; currentNoteBar++) {
                let row = currentNoteBar * subRows;
                //let beat: number = Math.round(((i * RowCount.PER_MEASURE + row) / 48) * 1000) / 1000;
                let beat = (i * 192 /* RowCount.PER_MEASURE */ + row) / 48;
                let type = this.getNoteType(row);
                let color = this.noteTypeToColor(type);
                for (var column = 0; column < column_count; column++) {
                    var NOTE_TYPE = measure.charAt((currentNoteBar * column_count) + column);
                    // Nothing
                    if (NOTE_TYPE == "0" /* NoteType.None */)
                        continue;
                    // Held Note End
                    if (NOTE_TYPE == "3" /* NoteType.End */) {
                        if (hold_mapping[column] != undefined) {
                            hold_mapping[column].end = beat;
                            delete hold_mapping[column];
                        }
                        continue;
                    }
                    // New Object
                    let noteObject = {
                        type: NOTE_TYPE,
                        beat: beat,
                        column: column,
                        snap: type,
                        color: color
                    };
                    if (NOTE_TYPE == "2" /* NoteType.Hold */ || NOTE_TYPE == "4" /* NoteType.Roll */) {
                        noteObject.end = -1;
                        hold_mapping[column] = noteObject;
                    }
                    output.push(noteObject);
                }
            }
        }
        return output;
    }
    finalizeNoteData(output) {
        let charts = output.charts;
        if (charts.length <= 0)
            return;
        charts.forEach(chart => {
            this.finalizeNoteSingle(output, chart);
        });
    }
    finalizeNoteSingle(output, chart) {
        //console.log("----------------------------------");
        //console.log(output);
        //console.log(chart);
        let allEvents = [];
        // Events: BPMs
        output.bpms.forEach(([beat, value], index) => {
            allEvents.push(new BPMEvent(beat, value, index));
        });
        // Events: Stops
        output.stops.forEach(([beat, value], index) => {
            allEvents.push(new StopEvent(beat, value * 1000, index));
        });
        // Events: Warps
        if (this.hasWarp) {
            this.calculateWarps(output, allEvents);
        }
        // Events: Notes
        chart.data.forEach((note, index) => {
            switch (note.type) {
                case "1" /* NoteType.Tap */: {
                    let noteEvent = new NoteEvent(index);
                    noteEvent.BEAT = note.beat;
                    noteEvent.COLUMN = note.column;
                    noteEvent.COLOR = note.color;
                    allEvents.push(noteEvent);
                    break;
                }
                case "2" /* NoteType.Hold */: {
                    let noteEvent = new HoldEvent(index);
                    noteEvent.BEAT = note.beat;
                    noteEvent.COLUMN = note.column;
                    noteEvent.COLOR = note.color;
                    noteEvent.BEAT_END = note.end;
                    allEvents.push(noteEvent);
                    let noteEndEvent = new HoldEndEvent(index);
                    noteEndEvent.HEAD = noteEvent;
                    noteEndEvent.BEAT = note.end;
                    allEvents.push(noteEndEvent);
                    break;
                }
                case "M" /* NoteType.Mine */: {
                    let noteEvent = new MineEvent(index);
                    noteEvent.BEAT = note.beat;
                    noteEvent.COLUMN = note.column;
                    noteEvent.COLOR = note.color; // Mines normally don't have a color.
                    allEvents.push(noteEvent);
                    break;
                }
            }
        });
        this.sortTimeline(allEvents);
        if (!(allEvents[0] instanceof BPMEvent)) {
            console.error("First Timeline Event isn't BPM!");
            return;
        }
        // Calculate Times
        let max_ms = output.offset * -1000;
        let sum_ms = max_ms;
        let last_event = allEvents[0];
        let last_bpm = allEvents[0];
        let is_warp = false;
        for (let i = 0; i < allEvents.length; i++) {
            const event = allEvents[i];
            const beat_difference = event.BEAT - last_event.BEAT;
            // Time Advancement (Normally)
            if (beat_difference > 0) {
                sum_ms += beat_difference * last_bpm.MS_PER_BEAT;
                sum_ms = Math.floor(sum_ms * 1000) / 1000;
                max_ms = Math.max(max_ms, sum_ms);
            }
            event.TIME = max_ms;
            // BPM Change
            if (event instanceof BPMEvent) {
                last_bpm.BEAT_END = event.BEAT;
                last_bpm.TIME_END = event.TIME;
                last_bpm = event;
            }
            // Hold/Roll End Points
            if (event instanceof HoldEndEvent) {
                event.HEAD.BEAT_END = event.BEAT;
                event.HEAD.TIME_END = event.TIME;
            }
            // Warp / Fake Regions
            if (event instanceof WarpEndEvent) {
                is_warp = false;
            }
            else if (event instanceof WarpEvent) {
                is_warp = true;
            }
            if (event instanceof NoteEvent) {
                event.FAKE = is_warp;
            }
            // Stops
            if (event instanceof StopEvent) {
                sum_ms += event.LENGTH;
                max_ms = Math.max(max_ms, sum_ms);
            }
            last_event = event;
        }
        chart.timeline = allEvents;
        /*
        let events = {
            all: allEvents,
            notes: allEvents.filter(item => item instanceof NoteEvent && !item.FAKE),
            fake: allEvents.filter(item => item instanceof NoteEvent && item.FAKE),
            hold_end: allEvents.filter(item => item instanceof HoldEndEvent),
            bpms: allEvents.filter(item => item instanceof BPMEvent),
            stops: allEvents.filter(item => item instanceof StopEvent),
            mines: allEvents.filter(item => item instanceof MineEvent),
            warps: allEvents.filter(item => item instanceof WarpEvent)
        };


        console.log(events);
        console.log(Math.floor(max_ms));
        */
    }
    /**
     * Calculate fake regions that are skipped due to negative BPM or negative Stop lengths.
     * This needs to be done before notes are calculated to determine what is real.
     * Hit Objects during these regions are still rendered in XMOD, but skipped in CMOD.
     * While this could be included in the main timeline calculation, warps are generally rare
     * and might add extra overhead for the majority of maps if always done.
     * @param output Raw Chart Info
     * @param allEvents Timeline
     */
    calculateWarps(output, allEvents) {
        this.sortTimeline(allEvents);
        if (!(allEvents[0] instanceof BPMEvent)) {
            console.error("First Timeline Event isn't BPM!");
            return;
        }
        let newEvents = [];
        let bpmIndex = output.bpms.length;
        // Calculate Times
        let max_ms = output.offset * -1000;
        let sum_ms = max_ms;
        let last_event = allEvents[0];
        let last_bpm = allEvents[0];
        let is_warp = false;
        for (let i = 0; i < allEvents.length; i++) {
            const event = allEvents[i];
            const beat_difference = event.BEAT - last_event.BEAT;
            // Warp
            const activeWarp = sum_ms < max_ms;
            const old_max_ms = max_ms;
            const sum_difference = old_max_ms - sum_ms;
            // Time Advancement (Normally)
            if (beat_difference > 0) {
                sum_ms += beat_difference * last_bpm.MS_PER_BEAT;
                sum_ms = Math.floor(sum_ms * 1000) / 1000;
                max_ms = Math.max(max_ms, sum_ms);
            }
            event.TIME = max_ms;
            // Warp End Points
            if (activeWarp && sum_ms >= old_max_ms) {
                const warp_end_beat = ((last_bpm.BEAT * 48) + Math.floor(sum_difference / last_bpm.MS_PER_ROW)) / 48;
                newEvents.push(new WarpEndEvent(warp_end_beat, old_max_ms, newEvents.length));
                is_warp = false;
                // Add Search BPM Event
                if (warp_end_beat != last_bpm.BEAT) {
                    newEvents.push(new BPMEvent(warp_end_beat, last_bpm.BPM, bpmIndex++));
                }
            }
            // BPM Change
            if (event instanceof BPMEvent) {
                last_bpm.BEAT_END = event.BEAT;
                last_bpm.TIME_END = event.TIME;
                last_bpm = event;
                if (event.BPM < 0 && !is_warp) {
                    newEvents.push(new WarpEvent(event.BEAT, max_ms, newEvents.length));
                    is_warp = true;
                }
            }
            // Stops
            if (event instanceof StopEvent) {
                sum_ms += event.LENGTH;
                max_ms = Math.max(max_ms, sum_ms);
                if (event.LENGTH < 0 && !is_warp) {
                    newEvents.push(new WarpEvent(event.BEAT, max_ms, newEvents.length));
                    is_warp = true;
                }
            }
            last_event = event;
        }
        allEvents.push(...newEvents);
    }
    keyPairSort(a, b) {
        return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0;
    }
    checkForWarp(list) {
        if (this.hasWarp)
            return true;
        const len = list.length;
        for (let i = 0; i < len; i++) {
            if (list[i][1] < 0) { // BPM or Time is negative.
                return true;
            }
        }
        return false;
    }
    getNoteType(noteIndex) {
        if (noteIndex % (192 /* RowCount.PER_MEASURE */ / 4) == 0)
            return 0 /* QuantizeType.TYPE_4TH */;
        else if (noteIndex % (192 /* RowCount.PER_MEASURE */ / 8) == 0)
            return 1 /* QuantizeType.TYPE_8TH */;
        else if (noteIndex % (192 /* RowCount.PER_MEASURE */ / 12) == 0)
            return 2 /* QuantizeType.TYPE_12TH */;
        else if (noteIndex % (192 /* RowCount.PER_MEASURE */ / 16) == 0)
            return 3 /* QuantizeType.TYPE_16TH */;
        else if (noteIndex % (192 /* RowCount.PER_MEASURE */ / 24) == 0)
            return 4 /* QuantizeType.TYPE_24TH */;
        else if (noteIndex % (192 /* RowCount.PER_MEASURE */ / 32) == 0)
            return 5 /* QuantizeType.TYPE_32ND */;
        else if (noteIndex % (192 /* RowCount.PER_MEASURE */ / 48) == 0)
            return 6 /* QuantizeType.TYPE_48TH */;
        else if (noteIndex % (192 /* RowCount.PER_MEASURE */ / 64) == 0)
            return 7 /* QuantizeType.TYPE_64TH */;
        else
            return 9 /* QuantizeType.TYPE_INVALID */;
    }
    noteTypeToColor(noteType) {
        switch (noteType) {
            case 0 /* QuantizeType.TYPE_4TH */:
                return 1 /* QuantizeColor.Red */;
            case 1 /* QuantizeType.TYPE_8TH */:
                return 0 /* QuantizeColor.Blue */;
            case 2 /* QuantizeType.TYPE_12TH */:
                return 2 /* QuantizeColor.Purple */;
            case 3 /* QuantizeType.TYPE_16TH */:
                return 3 /* QuantizeColor.Yellow */;
            case 4 /* QuantizeType.TYPE_24TH */:
                return 4 /* QuantizeColor.Pink */;
            case 5 /* QuantizeType.TYPE_32ND */:
                return 5 /* QuantizeColor.Orange */;
            case 6 /* QuantizeType.TYPE_48TH */:
                return 6 /* QuantizeColor.Cyan */;
            case 7 /* QuantizeType.TYPE_64TH */:
                return 7 /* QuantizeColor.Green */;
            default: // TYPE_192ND | TYPE_INVALID
                return 8 /* QuantizeColor.White */;
        }
    }
    smStandardType(type) {
        switch (type) {
            case 'dance-single':
                return 4;
            case 'dance-double':
            case 'dance-couple':
            case 'dance-routine':
                return 8;
            case 'dance-solo':
            case 'pump-halfdouble':
                return 6;
            case 'pump-single':
                return 5;
            case 'pump-double':
            case 'pump-couple':
                return 10;
        }
        return 0;
    }
    getListValues(input) {
        let output = [];
        if (input.length == 0)
            return output;
        let arrayValues = input.split(',');
        if (arrayValues.length == 0)
            return output;
        arrayValues.forEach((item) => {
            item = item.trim();
            let splitIndex = item.indexOf("=");
            if (splitIndex >= 1) {
                let beat = Math.round(parseFloat(item.substring(0, splitIndex)) * 48) / 48;
                let value = parseFloat(item.substring(splitIndex + 1));
                output.push([beat, value]);
            }
        });
        return output;
    }
}
ChartStepmania.fields_array = [
    'title',
    'subtitle',
    'artist',
    'titletranslit',
    'subtitletranslit',
    'artisttranslit',
    'credit',
    'banner',
    'background',
    'cdtitle',
    'music',
    'offset',
    'samplestart',
    'samplelength',
    'bpms',
    'stops',
    'freezes',
    'notes'
];
ChartStepmania.fields_number = [
    'offset',
    'samplestart',
    'samplelength'
];
